module.exports = __webpack_public_path__ + "static/media/slack.fe32bde4.svg";